<template>
  <div class="settings-deleted-patients-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Deleted Patients</h5>
    </div>
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-2"
    >
      <b-form-input
        style="width:300px"
        v-model="filter.searchPhrase"
        placeholder="Search by Name, MRN"
      />
      <top-paginator
        :total="listTotal"
        :page="filter.page"
        :perPage="filter.pageSize"
        @change-page="changePage"
      />
    </div>
    <div>
      <grid
        class=""
        ref="grid"
        :groupFeature="false"
        :columns="columns"
        :autoHeight="true"
        :data="deletedEocs"
        :columnLines="false"
        :searchFeature="true"
        :stripeFeature="false"
        @storesort="listeners.storeSort"
      ></grid>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import TopPaginator from "../controls/TopPaginator.vue";
import eoc from "../../server/eoc";
import { formatDate } from "../../helpers/date";

export default {
  name: "DeletedPatients",
  components: { Grid, TopPaginator },
  data() {
    const self = this;
    return {
      deletedEocs: [],
      listTotal: 0,
      filter: {
        page: 0,
        pageSize: 50,
        orderBy: "createdAt",
        orderByDescending: false,
        searchPhrase: ""
      },
      listeners: {
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.filter.orderBy = field;
            self.filter.orderByDescending = !ascending;
            self.changePage(0);
          }
        }
      }
    };
  },
  mounted() {
    this.getDeletedEocs();
  },
  watch: {
    "filter.searchPhrase": function() {
      this.filter.page = 0;
      if (
        this.filter.searchPhrase.length == 0 ||
        this.filter.searchPhrase.length >= 3
      ) {
        this.getDeletedEocs();
      }
    }
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getDeletedEocs() {
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      let result;
      this.lastTimeout = setTimeout(async () => {
        result = await eoc.findAllDeleted(
          {
            page: this.filter.page,
            pageSize: this.filter.pageSize,
            orderBy: this.filter.orderBy,
            orderByDescending: this.filter.orderByDescending,
            searchPhrase:
              this.filter.searchPhrase.length >= 3
                ? this.filter.searchPhrase
                : ""
          },
          {}
        );
        this.deletedEocs = result.episodesOfCare.map(x => ({
          id: x.id,
          name:
            x.patient.firstName +
            (x.patient.middleName ? " " + x.patient.middleName : "") +
            " " +
            x.patient.lastName,
          createdAt: this.formatDate(x.createdAt),
          mrn: x.mrnEocn,
          deletedAt: x.deletedAt,
          deletedBy: x.deletedByName
        }));
        this.listTotal = result.count;
      }, 1000);
    },
    async restoreEoc(data) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to restore this record?"
          },
          {
            view: "confirm"
          }
        )
        .then(async () => {
          await eoc.restore(data.id);
          this.showAlertSuccess();
          await this.getDeletedEocs();
        })
        .catch(function() {});
    },
    async changePage(page) {
      this.filter.page = page;
      this.getDeletedEocs();
    }
  },
  computed: {
    columns() {
      let columns = [];
      const self = this;

      columns.push({
        text: "Created",
        field: "createdAt",
        width: 250,
        editor: false,
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });

      columns.push({
        text: "Deleted At",
        field: "deletedAt",
        type: "template",
        width: 250,
        editor: false,
        template: data => formatDate(data.value)
      });

      columns.push({
        text: "Deleted By",
        field: "deletedBy",
        flex: 1
      });

      columns.push({
        text: "Name",
        field: "name",
        flex: 1,
        editor: false,
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });

      columns.push({
        text: "MRN",
        field: "mrn",
        width: 250,
        editor: false,
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });

      columns.push({
        text: "Actions",
        type: "action",
        cellCls: "pointer-cell",
        align: "right",
        width: 100,
        actions: [
          {
            tooltip: "Restore",
            renderer: () =>
              `<img class="b-action-item ml-2 mr-1" src="${
                this.isStandalone()
                  ? `/icons/restore.svg`
                  : `/desktop/icons/restore.svg`
              }">`,
            onClick: async ({ record }) => {
              await this.restoreEoc(record.data);
            }
          }
        ]
      });

      return columns;
    }
  }
};
</script>

<style>
.settings-deleted-patients-container .b-grid-container .b-container {
  max-height: calc(100vh - 281px);
}
</style>
